// @flow
import { VERIFICATION_REQUIRED } from '@airtm/utils/dist/constants/accountStatus';

export class AccountLimitedError extends Error {
  userStatus: string;
  restrictedStatus: string[];

  constructor(userStatus: string, restrictedStatus: string[]) {
    super('ACCOUNT_LIMITED');
    this.userStatus = userStatus;
    this.restrictedStatus = restrictedStatus;
    this.verificationRequired = userStatus === VERIFICATION_REQUIRED;
  }
}

export default (status: Array<string> | string, userStatus: string) => {
  const restrictedStatus = Array.isArray(status) ? status : [status];
  if (restrictedStatus.includes(userStatus)) {
    throw new AccountLimitedError(userStatus, restrictedStatus);
  }
};
